import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avmEmailAddresses',
    standalone: true,
})
export class AvmEmailAddressesPipe implements PipeTransform {
    /**
     * Formate une liste d'adresses e-mail.
     * @param bytes : Adresses e-mail séparées par des ";".
     */
    transform(addresses: string): string {
        if (!addresses) {
            return '';
        }

        let addressArray = addresses.split(';');

        let formatedAddresses = '';

        addressArray.forEach((x) => {
            x = x.trim();

            if (formatedAddresses !== '') {
                formatedAddresses += '; ';
            }

            const pos = x.indexOf('<');

            if (pos > 0) {
                let firstPart = x.substring(0, pos).trim();

                if (firstPart.length > 0) {
                    // Trim du caractère '"'
                    x = firstPart.replace(/^\"+/, '');
                    x = x.replace(/\"+$/, '');
                } else {
                    // Trim du caractère '<' au debut et du caractère '>' à la fin.
                    x = x.replace(/^<+/, '');
                    x = x.replace(/>+$/, '');
                }
            }

            formatedAddresses += x;
        });

        return formatedAddresses;
    }
}
